import actionTypes from 'Utils/actionTypes'

const actions = actionTypes('CURRENT_USER')

export default actions
